import { PriceStyle } from "@omni/ui/components/Price/price.style";
import { isDefined } from "@omni/utils/helper.utils";

import { usePriceContext } from "@/components/Price/context/price.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatPrice } from "@/utils/price.utils";

type Props = {
    className?: string;
};

export const Conversion = ({ className }: Props) => {
    const { t } = useGranite();

    const { conversionPrice, conversionUnit, size } = usePriceContext();

    const formattedPrice =
        isDefined(conversionPrice) && conversionUnit
            ? formatPrice(conversionPrice)
            : "";

    return (
        <span
            className={PriceStyle.conversion({
                size: size,
                className: className
            })}
        >
            {formattedPrice && (
                <>
                    <span className={PriceStyle.conversion.price()}>
                        {formattedPrice}
                    </span>{" "}
                    {t("general.per")} {conversionUnit}
                </>
            )}
        </span>
    );
};
